import { useQuery } from "@tanstack/react-query"
import { commonLocalesQuery } from "../lib/commonLocalesQuery"

export function useCommonLocalesQuery(...args: Parameters<typeof commonLocalesQuery>) {
  return useQuery(commonLocalesQuery(...args))
}
